<h1 mat-dialog-title>Share this entry</h1>

<div mat-dialog-content class="sed">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

    <div class="sed__alert" *ngIf="loadError" data-test="load-error">
        <mat-icon>error_outline</mat-icon>
        <div>{{ loadError }}</div>
    </div>

    <ng-container *ngIf="!isLoading && !loadError">
        <div class="sed__entry" data-test="entry">
            <mat-icon>description</mat-icon>
            <div>
                <div class="sed__entry-title">{{ data.entryTitle }}</div>
                <div class="hint">{{ data.patientName }}</div>
            </div>
        </div>

        <p class="hint" *ngIf="!options.length && switchedOffLinks" data-test="links-switched-off">
            Your referral network has {{ switchedOffLinks === 1 ? 'a link' : 'links' }}, but referrals are not switched on for this
            server, so nothing can be sent. Ask whoever runs it to switch referrals on.
        </p>
        <!-- §25: "no links" here means no PRACTICE links. A network of outside clinicians is not empty, and saying it is
             would contradict the settings tab; what it cannot do is receive one entry of a patient file. -->
        <p class="hint" *ngIf="!options.length && !switchedOffLinks" data-test="no-links">
            You have no active referral link yet. Link with a practice under Settings · MedicAI Network, or refer the patient
            to a clinician outside MedicAI first: after the referral letter, entries can follow within its document allowance.
        </p>

        <ng-container *ngIf="offered.length">
            <h3>Who should receive it?</h3>
            <div class="sed__choices" data-test="link-choices">
                <mat-checkbox *ngFor="let option of offered" [checked]="chosen.has(option.linkId)"
                    (change)="toggle(option.linkId, $event.checked)" data-test="link-choice">
                    {{ option.displayName }}
                    <span class="hint" *ngIf="describe(option) as detail"> · {{ detail }}</span>
                    <span class="hint" *ngIf="isLetterLink(option)"> · one of this patient's referral documents, after the referral letter</span>
                </mat-checkbox>
            </div>
        </ng-container>

        <p class="hint" *ngIf="alreadyHave.length" data-test="already-shared">
            Already has this entry: {{ alreadyHave.length === options.length ? 'every link' : '' }}
            <span *ngFor="let option of alreadyHave; let last = last">{{ option.displayName }}{{ last ? '' : ', ' }}</span>
        </p>

        <ng-container *ngIf="offered.length">
            <p class="hint">Only this entry is shared. The rest of the patient file stays where it is, and nothing shared can be
                unshared later.</p>
            <mat-checkbox [(ngModel)]="acknowledged" *ngIf="acknowledgement" data-test="acknowledge">{{ acknowledgement.text }}</mat-checkbox>

            <ul class="hint" *ngIf="submitAttempted && problems.length" data-test="problems">
                <li *ngFor="let problem of problems">{{ problem }}</li>
            </ul>
        </ng-container>

        <div class="sed__alert" *ngIf="actionError" data-test="action-error">
            <mat-icon>error_outline</mat-icon>
            <div>{{ actionError }}</div>
        </div>
    </ng-container>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="close()" [disabled]="isSaving">Close</button>
    <button mat-flat-button color="primary" (click)="share()" [disabled]="isSaving || !offered.length" data-test="share">
        {{ isSaving ? 'Sharing…' : 'Share' }}
    </button>
</div>
